module.exports = __webpack_public_path__ + "static/media/login.7c62b080.png";